<template>
    <div class="product-description">
        <div class="product-info-column product-info-column-details">
            <div class="product-info-content">
                <span class="result-label" v-if="isResultScreen">{{resources.screens.result.heading}}</span>
                <h3 v-if="isResultScreen">{{customizedHeading}}</h3>
                <h3 v-if="!isResultScreen">{{resources.screens.intro.heading}}</h3>
                <p v-if="!hideParagraph">{{resources.screens.intro.body}}</p>

                <div class="product-info-icons">
                    <div class="item" v-for="usp in usps">
                        <span class="product-info-icon">
                            <span :class="['icon', usp.icon]"></span>
                        </span>
                        <span class="info-text">
                            {{usp.label}}
                        </span>
                    </div>
                </div>

                <div class="product-info-footer">
                    <div class="product-price">
                        <div class="prices-container">
                            <span class="price-sales">
                                {{productData.price.formattedSale}}
                            </span>
                        </div>
                    </div>

                    <button type="button" class="btn btn-customize btn--secondary" v-if="!isResultScreen" @click="nextScreen()">
                        <span>{{resources.screens.intro.button.label}}</span>
                        <span :class="resources.screens.intro.button.icon"></span>
                    </button>

                    <button type="submit" class="btn" @click="addToCart()" v-if="isResultScreen">
                        {{resources.global.buttonAddToCart}}
                    </button>
                    <button type="submit" class="btn btn--secondary" @click="redirectToPDP()" v-if="isResultScreen">
                        {{resources.global.buttonDetails}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./product-description.js"></script>
